import { Injectable } from '@angular/core';
import { DynamicComponentService } from '../dynamic_components/dynamic.service';
import { IptvVideoComponent } from './iptv-video.component';
import { Channel } from '../IPTV_Editor/iptv_editor.component';
import { EPG_list } from '../iptv-epg/epg.interfaces';

@Injectable({providedIn: 'root'})
export class IPTVVideoService  {
    private _player:IptvVideoComponent = null;
    channel:Channel = null;
    constructor(private _DCService:DynamicComponentService) { }

    private get player():IptvVideoComponent{
        if(!this._player) {
            this._player = this._DCService.attach(IptvVideoComponent);
            if(this.channel) {
                this._player.channel = this.channel;
                this._player.plyr_epg_init();
                if(this.channel?.epg){
                    this.epgCurrent = Object.assign({},this.channel.epg[0]);
                }
            }
            this._player.destroyEmitter.subscribe(()=>{},()=>{},()=>{
                this._player = null;
                this.channel = null;
            })
        }
        return this._player;
    }
    private set player(player:IptvVideoComponent){
        this._player = player;
    }
    /**
     * Текущая программа передач, отображаемая в плеере.
     */
    set epgCurrent(epg:EPG_list){
        if(this._player) {
            this.player.epgCurrent = epg;
            this.player.plyr_update_interval();
        }
    }
    get epgCurrent(){
        return this.player.epgCurrent;
    }
    /**
     * Заголовок медиаплеера
     */
    set title(title:string) {
        if(this._player) {
            this.player.title = title;
        }
    }

    get title() {
        if(this._player) {
            return this._player.title;
        } else return "";
    }
    /**
     * Запуск канала
     * @param url Если не передана ссылка, тогда берется url из объекта Channel
     */
    play(url?:string){
        this.player.play(url);
    }
}